import { useModal } from "@/app/shared/modal-views/use-modal";
import {
    permissions,
    roles,
    statuses,
} from "@/app/shared/roles-permissions/utils";
import { Form } from "@/ui/form";
import {
    CreateUserInput,
    createUserSchema,
} from "@/validators/create-user.schema";
import { useState } from "react";
import { Controller, SubmitHandler } from "react-hook-form";
import { PiXBold } from "react-icons/pi";
import { ActionIcon, Button, Input, Select, Title } from "rizzui";
export default function CreateUser() {
    const { closeModal } = useModal();
    const [reset, setReset] = useState({});
    const [isLoading, setLoading] = useState(false);

    const onSubmit: SubmitHandler<CreateUserInput> = (data) => {
        // set timeout ony required to display loading state of the create category button
        const formattedData = {
            ...data,
            createdAt: new Date(),
        };
        setLoading(true);
        setTimeout(() => {
            console.log("formattedData", formattedData);
            setLoading(false);
            setReset({
                fullName: "",
                email: "",
                role: "",
                permissions: "",
                status: "",
            });
            closeModal();
        }, 600);
    };

    return (
        <Form<CreateUserInput>
            resetValues={reset}
            onSubmit={onSubmit}
            validationSchema={createUserSchema}
            className="grid grid-cols-1 gap-6 p-6 @container md:grid-cols-2 [&_.rizzui-input-label]:font-medium [&_.rizzui-input-label]:text-gray-900"
        >
            {({ register, control, formState: { errors } }) => {
                return (
                    <>
                        <div className="col-span-full flex items-center justify-between">
                            <Title as="h4" className="font-semibold">
                                Add a new User
                            </Title>
                            <ActionIcon
                                size="sm"
                                variant="text"
                                onClick={closeModal}
                            >
                                <PiXBold className="h-auto w-5" />
                            </ActionIcon>
                        </div>
                        <Input
                            label="Full Name"
                            placeholder="Enter user's full name"
                            {...register("fullName")}
                            className="col-span-full"
                            error={errors.fullName?.message}
                        />

                        <Input
                            label="Email"
                            placeholder="Enter user's Email Address"
                            className="col-span-full"
                            {...register("email")}
                            error={errors.email?.message}
                        />

                        <Controller
                            name="role"
                            control={control}
                            render={({ field: { name, onChange, value } }) => (
                                <Select
                                    options={roles}
                                    value={value}
                                    onChange={onChange}
                                    name={name}
                                    label="Role"
                                    className="col-span-full"
                                    error={errors?.status?.message}
                                    getOptionValue={(option) => option.value}
                                    displayValue={(selected: string) =>
                                        roles.find(
                                            (option) =>
                                                option.value === selected,
                                        )?.label ?? selected
                                    }
                                    dropdownClassName="!z-[1]"
                                    inPortal={false}
                                />
                            )}
                        />

                        <Controller
                            name="status"
                            control={control}
                            render={({ field: { name, onChange, value } }) => (
                                <Select
                                    options={statuses}
                                    value={value}
                                    onChange={onChange}
                                    name={name}
                                    label="Status"
                                    error={errors?.status?.message}
                                    getOptionValue={(option) => option.value}
                                    displayValue={(selected: string) =>
                                        statuses.find(
                                            (option) =>
                                                option.value === selected,
                                        )?.label ?? ""
                                    }
                                    dropdownClassName="!z-[1] h-auto"
                                    inPortal={false}
                                />
                            )}
                        />

                        <Controller
                            name="permissions"
                            control={control}
                            render={({ field: { name, onChange, value } }) => (
                                <Select
                                    options={permissions}
                                    value={value}
                                    onChange={onChange}
                                    name={name}
                                    label="Permissions"
                                    error={errors?.status?.message}
                                    getOptionValue={(option) => option.value}
                                    displayValue={(selected: string) =>
                                        permissions.find(
                                            (option) =>
                                                option.value === selected,
                                        )?.label ?? ""
                                    }
                                    dropdownClassName="!z-[1] h-auto"
                                    inPortal={false}
                                />
                            )}
                        />

                        <div className="col-span-full flex items-center justify-end gap-4">
                            <Button
                                variant="outline"
                                onClick={closeModal}
                                className="w-full @xl:w-auto"
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                isLoading={isLoading}
                                className="w-full @xl:w-auto"
                            >
                                Create User
                            </Button>
                        </div>
                    </>
                );
            }}
        </Form>
    );
}
